// src/services/localStorageService.js
const localStorageKeyEnum = {
  tokenKey: "token",
  userDetails: "userDetails",
  role: "role",
}

const localStorageService = {
  // Save the UserDetails
  setUserDetails: (value) => {
    localStorage.setItem(localStorageKeyEnum.userDetails, JSON.stringify(value));
  },

  // Retrive the UserDetails
  getUserDetails: () => {
    return JSON.parse(localStorage.getItem(localStorageKeyEnum.userDetails));
  },

  // Save token
  setToken: (token) => {
    localStorage.setItem(localStorageKeyEnum.tokenKey, token);
  },

  // Retrieve token
  getToken: () => {
    return localStorage.getItem(localStorageKeyEnum.tokenKey);
  },
  // Save token
  setRole: (token) => {
    localStorage.setItem(localStorageKeyEnum.role, token);
  },

  // Retrieve token
  getRole: () => {
    return localStorage.getItem(localStorageKeyEnum.role);
  },

  // Remove token (e.g., on logout)
  clearToken: () => {
    localStorage.removeItem(localStorageKeyEnum.tokenKey);
  },

  // Remove All dsata
  clearAll: () => {
    localStorage.clear();
  },
};

export default localStorageService;
